import type { FunctionComponent } from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";

import { BaseLink } from "shared/components/common/base-link";

import type { ShowInVariant } from "scmp-app/components/header/features/styles";
import { useMastheadTracking } from "scmp-app/components/header/hooks";
import { page as NewsletterPage } from "scmp-app/pages/newsletters";

import { Container, StyledIconNewsletter } from "./styles";

export type HeaderFeaturesNewsletterProps = {
  showIn?: ShowInVariant;
};

export const HeaderFeaturesNewsletter: FunctionComponent<HeaderFeaturesNewsletterProps> = ({
  showIn,
}) => {
  const { handleTrackGA4 } = useSdkContext();

  const handleClick = () => {
    handleTrackGA4({
      action: "click",
      category: "nl",
      customized_parameters: {
        internal_campaign: "",
        trigger_point: "masthead",
      },
      subcategory: "entry",
    });
  };

  const mastheadQueryParameter = useMastheadTracking();

  return (
    <Container $showIn={showIn}>
      <BaseLink
        anchorProps={{ "aria-label": "newsletter" }}
        {...NewsletterPage.route({})}
        onClick={handleClick}
        query={mastheadQueryParameter}
      >
        <StyledIconNewsletter />
      </BaseLink>
    </Container>
  );
};
